import { HttpService } from './http.service'
import { apiRoutes } from '../routing/api-routes'
import { Feedback, FeedbackPayload } from 'app/modules/shared/types/feedback'

export const feedbacksService = {
  submitFeedback: (feedbackPayload: FeedbackPayload): Promise<Feedback> => {
    return HttpService.post(apiRoutes.postFeedback, feedbackPayload)
  },
  getFeedbacks: (params: {
    page: number
    search?: string
    type?: 'report' | 'product'
    is_useful?: boolean
    min_score?: number
    max_score?: number
    date_from?: string
    date_to?: string
  }): Promise<{ items: Feedback[]; total_count: number; matched_count?: number }> => {
    return HttpService.get(apiRoutes.getFeedbacks, { params })
  },
}
